import React from "react";
import FilterRow from "./FilterRow";

/**
 * The list of filter rows plus an "add filter" control.
 * @param {object} props
 * @param {Array<object>} props.filters the filter rows (each with a stable `_id`).
 * @param {Array<object>} props.fields the module's field metadata.
 * @param {() => void} props.onAdd adds a filter row.
 * @param {(index: number, patch: object) => void} props.onChange updates a row.
 * @param {(index: number) => void} props.onRemove removes a row.
 * @returns {JSX.Element}
 */
export default function FilterBuilder({
  filters,
  fields,
  onAdd,
  onChange,
  onRemove,
}) {
  return (
    <div className="qb-field">
      <span className="qb-label">Rules</span>
      {filters.length === 0 && (
        <p className="qb-muted">No rules — every row matches.</p>
      )}
      {filters.map((filter, index) => (
        <FilterRow
          key={filter._id}
          index={index}
          filter={filter}
          fields={fields}
          onChange={onChange}
          onRemove={onRemove}
        />
      ))}
      <button type="button" className="qb-btn qb-btn-ghost" onClick={onAdd}>
        + Add rule
      </button>
    </div>
  );
}
